export default {
  data() {
    return {
      region: {},
      date: "",
      showPicker: false,
      showDatePicker: false,
    };
  },
  created() {
    this.initDate();
  },
  // mounted() {
  //   this.$nextTick(function () {
  //     document.documentElement.scrollTop = document.body.scrollTop = 0;
  //   });
  // },
  methods: {
    onMonthConfirm(date) {
      this.showDatePicker = false;
      this.initDate(date);
    },
    onCityConfirm(region) {
      this.region = region;
      this.showPicker = false;
    },
    onCityOpen() {
      this.showPicker = true;
    },
    onDateOpen() {
      this.showDatePicker = true;
    },
    initDate(date) {
      date = date || new Date();
      this.date = date;
    },
  },
};
